// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__mPmuk","link":"Header_link__nBluz","regular":"Header_regular__5i180","smallMobile":"Header_smallMobile__Yt6ky"};